<template>
  <div class="list-button" v-loading="list_params.loading">
    <div v-if="list_params.loading">
      <span>加载中...</span>
    </div>
    <div v-else-if="list_params.finished">
      <span>这是我的底线哦~!</span>
    </div>
    <div v-else-if="list_params.error" @click="refreshFn">
      <span>{{ error_text }}，点击刷新！</span>
    </div>
    <div v-else @click="nextFn">
      <i class="iconfont iconyanjing"></i>
      <span>查看更多</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "list-more",
  props: {
    gridList: {
      type: Object,
    },
  },
  computed: {
    list_params() {
      const { default_list, gridList } = this;

      return Object.assign({}, default_list, gridList);
    },
    error_text() {
      const {
        error
      } = this.gridList

      return error && typeof error === "string"? error: "出错啦"
    }
  },
  data() {
    return {
      default_list: {
        error: false,
        finished: false,
        loading: false,
      },
    };
  },
  methods: {
    nextFn() {
      this.$emit("next");
    },
    refreshFn() {
      this.$emit("error-refresh");
    },
  },
};
</script>

<style lang="scss" scoped>
.list-button {
  text-align: center;
  background-color: #f3f3f3;
  height: 0.5rem;
  line-height: 0.5rem;
  box-sizing: border-box;
  overflow: hidden;
  @include border-radius(0.1rem);

  > div {
    cursor: pointer;
    box-sizing: border-box;
    span,
    i {
      line-height: 0.22rem;
      font-size: 0.16rem;
      color: #999999;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/List/Bottom.vue